import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { getPortalTheme } from './portalThemes.js';
import { PORTAL } from './portals.js';

/**
 * ThemeProvider for v2 design system
 * Wraps children with MUI ThemeProvider using token-based theme configuration
 * 
 * Usage:
 * ```jsx
 * import { ThemeProvider } from './theme-v2/ThemeProvider';
 * 
 * function App() {
 *   return (
 *     <ThemeProvider portal={PORTAL.KUNDENPORTAL}>
 *       <YourComponents />
 *     </ThemeProvider>
 *   );
 * }
 * ```
 */
export default function ThemeProvider({ children, portal = PORTAL.SCHADENPORTAL })
{
    return (
        <MuiThemeProvider theme={getPortalTheme(portal)}>
            <CssBaseline />
            {children}
        </MuiThemeProvider>
    );
}
